import { render, staticRenderFns } from "./BaseTotalRows.vue?vue&type=template&id=3bfcf072&scoped=true"
import script from "./BaseTotalRows.vue?vue&type=script&lang=js"
export * from "./BaseTotalRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfcf072",
  null
  
)

export default component.exports